module.exports = __webpack_public_path__ + "img/close-icon.894e99ad.png";